import { render, staticRenderFns } from "./professionalCertification.vue?vue&type=template&id=7623cf90&scoped=true"
import script from "./professionalCertification.vue?vue&type=script&lang=js"
export * from "./professionalCertification.vue?vue&type=script&lang=js"
import style0 from "./professionalCertification.vue?vue&type=style&index=0&id=7623cf90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623cf90",
  null
  
)

export default component.exports